import * as React from 'react';
import autobind from 'autobind-decorator';
import { resolve } from 'inversify-react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import { DocumentService } from 'src/app/shared/document.service';
import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { ControllerProps } from 'src/router';
import { EmailDocumentTemplateListView } from './email-document-template-list.view';
import { EmailDocumentTemplateListDataService } from './email-document-template-list.data';

@observer
export class EmailDocumentTemplateListController extends React.Component<ControllerProps<any>, any> {

	@resolve
	toast: ToastNotifications;

	@observable
	dataService: EmailDocumentTemplateListDataService;

	constructor(props: ControllerProps<any>) {
		super(props);
	}

	@autobind
	private async loadData(): Promise<void> {
		this.dataService = EmailDocumentTemplateListDataService.make();

		this.dataService.addFilter('isDeleted', 'eq', false);
		this.dataService.addSorting('id', 'asc', true);
		this.dataService.pageSize = 25;

		await this.dataService.load(query => query);
	}
	

	@autobind
	onItemDoubleClicked(item: IEmailDocumentTemplateSummary): void {
		this.props.history.push(`/general/email-document-templates/${item == null ? 'new' : item.id}`);
	}

	componentDidMount() {
		this.props.setBusy(true);

		this.loadData()
			.catch((error) => {
				this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
			})
			.then(() => {
				this.props.setBusy(false);
			});
	}

	render() {
		return (
			<EmailDocumentTemplateListView
				model={this.dataService}
				setBusy={this.props.setBusy}
				onItemDoubleClicked={this.onItemDoubleClicked}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/email-document-template/list/email-document-template-list.controller.tsx